import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { logoUrl } from '../mockData';

const TerminiCondizioni = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 text-[#1B2380] hover:text-[#0E8C84] transition-colors duration-300"
            >
              <ArrowLeft size={20} />
              <span className="font-medium">Torna alla Home</span>
            </button>
            <img src={logoUrl} alt="Assietica" className="h-12 w-auto" />
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12">
          <h1 className="text-3xl sm:text-4xl font-bold text-[#1B2380] mb-8">
            Termini e Condizioni d'Uso del Sito
          </h1>

          <div className="prose prose-lg max-w-none text-gray-700">
            {/* Oggetto del servizio */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#1B2380] mb-4">Oggetto del servizio</h2>
              <p className="leading-relaxed">
                Il presente sito web è di proprietà di <strong>Assietica Soc Coop Società Benefit</strong>. 
                Attraverso le sue aree funzionali, l'utente interessato a coperture assicurative può richiedere 
                una quotazione personalizzata.
              </p>
              <p className="leading-relaxed mt-4">
                Si precisa che quanto riportato nel sito non costituisce documentazione contrattuale. L'utente 
                è invitato a visionare tutta la documentazione obbligatoria ai sensi del Regolamento IVASS n. 40/2018 
                e n. 41/2018, ovvero la documentazione precontrattuale dell'intermediario (Allegati 3, 4 e 4-ter).
              </p>
            </section>

            {/* Richiesta di quotazione */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#1B2380] mb-4">Richiesta di quotazione e documentazione</h2>
              <p className="leading-relaxed">
                All'atto della richiesta di quotazione, l'utente riceverà via e-mail la suddetta documentazione 
                unitamente ai set informativi specifici per il prodotto richiesto (DIP, DIP Aggiuntivo, Condizioni 
                di Polizza ed eventuale proposta di adesione). La richiesta di quotazione è gratuita e non vincolante. 
                L'emissione della polizza resta a discrezione delle Compagnie Assicurative mandanti.
              </p>
            </section>

            {/* Scelta del cliente */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#1B2380] mb-4">Scelta del cliente e consulenza</h2>
              <p className="leading-relaxed">
                Per l'attività di vendita a seguito dell'accettazione delle quotazioni inviate, Assietica Soc Coop 
                Società Benefit precisa che, salvo ove diversamente indicato, non fornisce una consulenza al cliente 
                ai sensi dell'art. 119-ter comma 3 del CAP (Codice delle Assicurazioni Private), ovvero una 
                raccomandazione personalizzata.
              </p>
            </section>

            {/* Supporto durevole */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#1B2380] mb-4">Supporto durevole e Correttezza delle informazioni</h2>
              <p className="leading-relaxed">
                Tutta la documentazione sarà inviata su supporto durevole (e-mail o PDF). Il cliente può richiedere 
                la documentazione cartacea in qualsiasi momento scrivendo a{' '}
                <a href="mailto:agenzia@assietica.it" className="text-[#0E8C84] hover:underline">
                  agenzia@assietica.it
                </a>{' '}
                o via PEC a{' '}
                <a href="mailto:cdsp@pec.confcooperative.it" className="text-[#0E8C84] hover:underline">
                  cdsp@pec.confcooperative.it
                </a>.
              </p>
              <p className="leading-relaxed mt-4">
                Il cliente è tenuto a fornire informazioni vere e complete ai sensi degli Artt. 1892/1893 del Codice 
                Civile per evitare l'invalidità della copertura.
              </p>
            </section>

            {/* Diritto di ripensamento */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#1B2380] mb-4">Diritto di ripensamento</h2>
              <p className="leading-relaxed">
                Ai sensi dell'art. 54 del Codice del Consumo, per gli acquisti online è esercitabile il diritto di 
                ripensamento entro 15 giorni dalla data di emissione della polizza (fatte salve le eccezioni di legge 
                per polizze di durata inferiore al mese).
              </p>
            </section>

            {/* Pagamenti */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#1B2380] mb-4">Pagamenti</h2>
              <p className="leading-relaxed">
                Il pagamento del premio deve avvenire solo a seguito di ricezione di comunicazione ufficiale di 
                Assietica Soc Coop Società Benefit contenente i dati identificativi del contratto e l'IBAN del 
                Conto Separato dell'intermediario. I pagamenti non autorizzati verranno rimborsati e non produrranno 
                effetti in termini di copertura. La copertura decorre dalle ore 24:00 del giorno di effettiva 
                disponibilità della somma sul conto separato.
              </p>
            </section>

            {/* Regole di condotta */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#1B2380] mb-4">Regole di condotta e Proprietà Intellettuale</h2>
              <p className="leading-relaxed">
                L'utente si impegna a utilizzare il sito per finalità legittime e a fornire dati veritieri. 
                I contenuti del sito sono di esclusiva titolarità di Assietica Soc Coop Società Benefit. 
                È vietata la riproduzione o l'utilizzo commerciale dei contenuti senza autorizzazione.
              </p>
            </section>

            {/* Informazioni sull'Intermediario */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#1B2380] mb-4">Informazioni sull'Intermediario</h2>
              <p className="leading-relaxed">
                L'attività di intermediazione è svolta da <strong>Assietica Soc Coop Società Benefit</strong>, 
                iscritta al RUI (Registro Unico degli Intermediari). La tutela del cliente per errori professionali 
                è garantita da idonea polizza di responsabilità civile professionale.
              </p>
            </section>
          </div>

          {/* Back button */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-[#1B2380] to-[#0E8C84] text-white px-8 py-3 rounded-lg font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300"
            >
              Torna alla Home
            </button>
          </div>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="bg-[#10154F] text-white py-6 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm text-white/70">
            © {new Date().getFullYear()} Assietica Società Cooperativa. Tutti i diritti riservati.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TerminiCondizioni;
